/* Surprizelo – înlocuiește emoji-urile din texte (descrieri, titluri, secțiuni)
   cu iconițe liniare în stilul temei. Textele din Shopify Admin rămân neschimbate. */
(function () {
  var P = {
    check: '<path d="M5 12.5l4.2 4.2L19 7"/>',
    truck: '<path d="M2.5 6.5h11v9h-11zM13.5 9.5h4l3 3.2v2.8h-7"/><circle cx="6.5" cy="17" r="1.7"/><circle cx="17" cy="17" r="1.7"/>',
    box: '<path d="M3.5 7.5 12 3.5l8.5 4v9L12 20.5l-8.5-4zM3.5 7.5 12 11.5l8.5-4M12 11.5v9M7.8 5.5l8.5 4"/>',
    hourglass: '<path d="M7 3.5h10M7 20.5h10M8 3.5c0 4 4 5.5 4 8.5s-4 4.5-4 8.5M16 3.5c0 4-4 5.5-4 8.5s4 4.5 4 8.5M9.8 18.3h4.4"/>',
    calendar: '<rect x="3.5" y="5" width="17" height="15.5" rx="1.5"/><path d="M3.5 9.5h17M8 3v4M16 3v4M8 13.5h.01M12 13.5h.01M16 13.5h.01M8 17h.01M12 17h.01"/>',
    sparkle: '<path d="M11 3c.6 4.4 2.6 6.4 7 7-4.4.6-6.4 2.6-7 7-.6-4.4-2.6-6.4-7-7 4.4-.6 6.4-2.6 7-7zM18.5 15c.2 1.6 1 2.3 2.5 2.5-1.5.2-2.3.9-2.5 2.5-.2-1.6-1-2.3-2.5-2.5 1.5-.2 2.3-.9 2.5-2.5z"/>',
    gift: '<path d="M4 9h16v3.5H4zM5.5 12.5h13V20h-13zM12 9v11M12 9C10.5 5 7 4.5 7 6.8S10.5 9 12 9c1.5 0 5 .5 5-2.2S13.5 5 12 9"/>',
    bow: '<path d="M10.8 11.6C9 8.8 4.9 7 4.4 9.3s.6 3.9 2.6 4.3c1.4.3 2.6-.5 3.8-2M13.2 11.6C15 8.8 19.1 7 19.6 9.3s-.6 3.9-2.6 4.3c-1.4.3-2.6-.5-3.8-2M11 13l-3 7M13 13l3 7"/><circle cx="12" cy="11.8" r="1.3"/>',
    heart: '<path d="M12 20s-7.5-4.6-7.5-10A4.3 4.3 0 0 1 12 7.3 4.3 4.3 0 0 1 19.5 10c0 5.4-7.5 10-7.5 10z"/>',
    flower: '<circle cx="12" cy="12" r="2"/><g><path d="M12 10c-1.7-1.7-1.9-4.6 0-6.5 1.9 1.9 1.7 4.8 0 6.5z"/><path d="M12 10c-1.7-1.7-1.9-4.6 0-6.5 1.9 1.9 1.7 4.8 0 6.5z" transform="rotate(72 12 12)"/><path d="M12 10c-1.7-1.7-1.9-4.6 0-6.5 1.9 1.9 1.7 4.8 0 6.5z" transform="rotate(144 12 12)"/><path d="M12 10c-1.7-1.7-1.9-4.6 0-6.5 1.9 1.9 1.7 4.8 0 6.5z" transform="rotate(216 12 12)"/><path d="M12 10c-1.7-1.7-1.9-4.6 0-6.5 1.9 1.9 1.7 4.8 0 6.5z" transform="rotate(288 12 12)"/></g>',
    tulip: '<path d="M12 13c-3.5 0-5-2.5-5-6.5l2.5 2L12 5l2.5 3.5L17 6.5c0 4-1.5 6.5-5 6.5zM12 13v8M12 18.5c-1.5-2-3.5-2.5-5-2M12 17.5c1.5-1.5 3-2 4.5-1.5"/>',
    bouquet: '<circle cx="8.5" cy="7.5" r="2.5"/><circle cx="15.5" cy="7.5" r="2.5"/><circle cx="12" cy="5" r="2.5"/><path d="M6.5 11h11L12 21zM12 11V7.5"/>',
    rose: '<path d="M12 4c3 0 5 2 5 4.5S15 13 12 13s-5-2-5-4.5S9 4 12 4zM12 7c1.2-.8 2.5 0 2.2 1.2-.3 1.4-2.4 1.8-3.4.8-1.2-1.2-.6-3.4 1.3-3.8M12 13v8M12 17.5c-1.8-1.6-3.8-1.4-4.8-.4 1.6 1 3.4 1.2 4.8.4"/>',
    strawberry: '<path d="M12 7.5c4 0 6.5 2 6.5 5 0 4-3.5 8-6.5 8s-6.5-4-6.5-8c0-3 2.5-5 6.5-5zM8.5 6 12 7.5 15.5 6M12 7.5V4M10 12h.01M14 12h.01M12 15h.01M10 17.5h.01M14 17.5h.01"/>',
    apple: '<path d="M12 8c-1.5-1-6-1.5-6.5 3.5-.4 4 2.2 8.5 4.5 8.5 1 0 1.3-.5 2-.5s1 .5 2 .5c2.3 0 4.9-4.5 4.5-8.5C18 6.5 13.5 7 12 8zM12 8c0-2 .5-3.5 2-4.5M12.5 6c1-1.5 3-2 4-1.5-.5 1.5-2.5 2-4 1.5"/>',
    lemon: '<path d="M5.2 15.6C3.7 11.6 7.2 6.1 12.2 5.1c3-.6 5.5.5 6.5 2.5 1.5 4-2 9.5-7 10.5-3 .6-5.5-.5-6.5-2.5zM4.4 17.6l.9-.9M19.6 5.4l-.9.9"/>',
    search: '<circle cx="10.5" cy="10.5" r="6"/><path d="M15 15l5 5"/>',
    bear: '<circle cx="12" cy="9.5" r="4.5"/><circle cx="7.8" cy="5.6" r="1.8"/><circle cx="16.2" cy="5.6" r="1.8"/><path d="M8.3 20.5c-1-3.6.9-6.6 3.7-6.6s4.7 3 3.7 6.6zM11 10.8h2M10.5 8.3h.01M13.5 8.3h.01"/>',
    rabbit: '<path d="M10 9C8.5 6 8.6 2.5 9.8 2.5S11.8 6 11.3 9M14 9c1.5-3 1.4-6.5.2-6.5S12.2 6 12.7 9M10 13.5h.01M14 13.5h.01M11.2 15.6h1.6"/><circle cx="12" cy="14.2" r="5.5"/>',
    party: '<path d="M4 20l4-11 7 7zM14 3.5v2M18.5 8h2M17.5 4.5 16 6M20.5 12l-1.6.4M11 6c1 1 1 2.5 0 3.5"/>',
    candy: '<circle cx="12" cy="12" r="3.8"/><path d="M8.5 10.5 4 8.5v7l4.5-2M15.5 10.5 20 8.5v7l-4.5-2"/>',
    chocolate: '<rect x="6" y="3.5" width="12" height="17" rx="1"/><path d="M6 9.2h12M6 14.8h12M12 3.5v17"/>',
    nut: '<path d="M9.5 3.5c2.6 0 4.2 2.1 3.7 4.6-.3 1.5.8 2.4 1.5 3.5 1.4 2.6-.4 7.4-4.2 7.4-3.5 0-5.6-3.1-4.9-6.2.3-1.4 1.4-2.3 1.4-4.1 0-2.6.6-5.2 2.5-5.2zM8.5 8h.01M10.5 14h.01M9 16.5h.01"/>',
    cup: '<path d="M4 9h12v5a5 5 0 0 1-5 5H9a5 5 0 0 1-5-5zM16 10.5h1.5a2.5 2.5 0 0 1 0 5H16M7.5 3.5c-.8 1 .8 2 0 3M11 3.5c-.8 1 .8 2 0 3"/>',
    scale: '<path d="M12 4v16M8 20h8M5 7h14M5 7l-2.5 6h5zM19 7l-2.5 6h5zM2.5 13c.3 1.2 1.3 2 2.5 2s2.2-.8 2.5-2M16.5 13c.3 1.2 1.3 2 2.5 2s2.2-.8 2.5-2"/>'
  };

  var MAP = {
    '✔': 'check', '✅': 'check', '☑': 'check', '✓': 'check',
    '🚚': 'truck', '🚛': 'truck', '📦': 'box',
    '⏳': 'hourglass', '⌛': 'hourglass', '📅': 'calendar', '📆': 'calendar', '🗓': 'calendar',
    '✨': 'sparkle', '💫': 'sparkle', '⭐': 'sparkle', '🌟': 'sparkle',
    '🎁': 'gift', '🎀': 'bow', '💝': 'gift',
    '🤍': 'heart', '💗': 'heart', '💕': 'heart', '💖': 'heart', '❤': 'heart',
    '💜': 'heart', '💙': 'heart', '💛': 'heart', '💚': 'heart', '🧡': 'heart',
    '💓': 'heart', '💞': 'heart', '💘': 'heart', '🩷': 'heart', '🖤': 'heart', '🤎': 'heart', '☕': 'cup',
    '🌸': 'flower', '🌼': 'flower', '🌺': 'flower', '🌻': 'flower', '🏵': 'flower',
    '🌷': 'tulip', '💐': 'bouquet', '🌹': 'rose',
    '🍓': 'strawberry', '🍏': 'apple', '🍎': 'apple', '🍋': 'lemon',
    '🔍': 'search', '🔎': 'search',
    '🧸': 'bear', '🐰': 'rabbit', '🐇': 'rabbit',
    '🎉': 'party', '🎊': 'party', '🎂': 'party',
    '🍬': 'candy', '🍭': 'candy', '🍫': 'chocolate', '🥜': 'nut', '⚖': 'scale'
  };

  var keys = Object.keys(MAP).sort(function (a, b) { return b.length - a.length; });
  var RE = new RegExp('(' + keys.join('|') + ')[\\uFE0F\\uFE0E\\u200D]*', 'g');
  var TEST = new RegExp(keys.join('|'));
  var SKIP = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, INPUT: 1, SELECT: 1, OPTION: 1, NOSCRIPT: 1, TITLE: 1, svg: 1, SVG: 1 };

  function icon(name) {
    return '<span class="sz-ico sz-ico--' + name + '" aria-hidden="true"><svg viewBox="0 0 24 24" width="1em" height="1em" fill="none" stroke="currentColor" ' +
      'stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" focusable="false">' + P[name] + '</svg></span>';
  }

  /* Iconițe care nu se afișează deloc (sunt doar scoase din text) */
  var REMOVE = { heart: 1 };
  /* În titluri (produs, carduri, coș, căutare, breadcrumb) emoji-urile se scot complet */
  var TITLE_SEL = 'h1, h2, h3, h4, [class*="product_title"], [class*="product-title"], .sz-card__title, .pv-cart__title, .pv-hit, .pv-crumbs, .cart-item__title, .cart-items__title, .predictive-search a, nav[aria-label*="readcrumb"]';
  var ANY_EMOJI = /(?:[☀-➿⬀-⯿⌚-⏿]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|\uD83E[\uDC00-\uDFFF])[️︎‍]*/g;

  function replaceNode(node) {
    var text = node.nodeValue;
    if (!TEST.test(text)) return;
    if (node.parentNode.closest(TITLE_SEL)) {
      var endsWithEmoji = /(?:[☀-➿⬀-⯿⌚-⏿]|[\uD83C-\uD83E][\uDC00-\uDFFF])[️︎‍]*\s*$/.test(text);
      var clean = text.replace(ANY_EMOJI, '').replace(/[️‍]/g, '').replace(/ {2,}/g, ' ');
      node.nodeValue = endsWithEmoji ? clean.replace(/\s+$/, '') : clean;
      return;
    }
    var span = document.createElement('span');
    span.className = 'sz-ico-text';
    span.innerHTML = text
      .replace(/[&<>]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c]; })
      .replace(new RegExp('\\s?' + RE.source, 'g'), function (m, emoji) {
        if (REMOVE[MAP[emoji]]) return '';
        return (m.charAt(0) === ' ' ? ' ' : '') + icon(MAP[emoji]);
      });
    node.parentNode.replaceChild(span, node);
  }

  function scan(root) {
    if (!root || root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.nodeType === 1 && (SKIP[root.nodeName] || root.closest('[contenteditable], .sz-ico'))) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        var p = n.parentNode;
        if (!p || SKIP[p.nodeName] || p.closest('svg, [contenteditable], .sz-ico')) return NodeFilter.FILTER_REJECT;
        return TEST.test(n.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      }
    });
    var found = [];
    while (walker.nextNode()) found.push(walker.currentNode);
    found.forEach(replaceNode);
  }

  function start() {
    scan(document.body);
    /* Horizon reîncarcă bucăți de pagină (variante, coș, căutare) – le procesăm și pe acelea */
    var pending = [];
    var queued = false;
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType === 1) pending.push(n);
          else if (n.nodeType === 3 && n.parentNode) pending.push(n.parentNode);
        });
      });
      if (!queued && pending.length) {
        queued = true;
        requestAnimationFrame(function () {
          var list = pending; pending = []; queued = false;
          list.forEach(function (n) { if (n.isConnected) scan(n); });
        });
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
